import { QUESTION_POSITION } from "../templates/strings";

// in multi select question, answer action could be multi or any outcome only!
export const hasOutcomeAsAnsActionInMultiQuestion = (collection) =>
  collection.some((ans) => ans.answerAction !== QUESTION_POSITION.multi);

export const appendScriptHtml = (scriptText, targetPlace) => {
  scriptText = scriptText?.trim();
  if (!scriptText) return;

  const scriptHtml = document.createElement(targetPlace.tagName); // just for creating container to copy DOM (tagName is not specific)
  scriptHtml.innerHTML = scriptText;

  if (scriptHtml.childNodes[0]?.nodeType === Node.TEXT_NODE) {
    scriptHtml.innerHTML = `<script>${scriptText}</script>`;
  }

  const scriptTags = Array.from(scriptHtml.getElementsByTagName("script"));
  scriptTags.forEach((scriptNode) => {
    const copy = copyScript(scriptNode);
    targetPlace.appendChild(copy);
    scriptNode.replaceChildren?.();
    scriptNode.remove?.();
  });

  const nodes = Array.from(scriptHtml.children);
  for (let node of nodes) {
    targetPlace.appendChild(node);
  }

  scriptHtml.replaceChildren();

  return;

  function copyScript(original) {
    if (!(original instanceof HTMLScriptElement)) {
      throw new Error("Element must be a <script>");
    }

    const copy = document.createElement("script");
    for (const attr of original.attributes) {
      copy.setAttribute(attr.name, attr.value);
    }

    if (original.textContent && original.textContent.trim()) {
      copy.textContent = original.textContent;
    }
    return copy;
  }
};

export const partitionPolicyText = ({
  checkboxText,
  checkboxClickableKeyword
}) => {
  const [prefix, ...rest] = (checkboxText || "").split(
    checkboxClickableKeyword
  );
  return {
    prefix,
    clickable: checkboxClickableKeyword,
    suffix: rest.join(checkboxClickableKeyword)
  };
};

// The global consent text is loaded with the funnel. If that request failed,
// there is no text to show and no policy version to store with the lead.
export const isGlobalPolicyMissing = ({ policyScope, amPrivacyPolicy }) =>
  policyScope === "GLOBAL" && !amPrivacyPolicy?._id;

export const POLICY_MISSING_MESSAGE =
  "Die Datenschutzerklärung konnte nicht geladen werden. Bitte laden Sie die Seite neu.";

export const generatePolicyScope = ({ funnel, reclaimMode }) =>
  reclaimMode.enabled || funnel.companyInfo?.requirePrivacyConsent
    ? "GLOBAL"
    : funnel.design?.policyDisplay && "FUNNEL";

export const generatePolicyVersion = ({
  funnel,
  reclaimMode,
  amPrivacyPolicy
}) => {
  const policyScope = generatePolicyScope({ funnel, reclaimMode });
  if (policyScope === "GLOBAL") {
    return amPrivacyPolicy?._id;
  }
  if (policyScope === "FUNNEL") {
    return funnel.policyVersion?._id || funnel.policyVersion;
  }
  return undefined;
};
